// Generated by scripts/generate-icon-subset.mjs — do not edit.
// Add or remove icons in icon-names.json, then run `npm run generate-icons`.

export const ICON_CODEPOINTS = {
  add: 0xe145,
  arrow_downward: 0xe5db,
  arrow_upward: 0xe5d8,
  attach_money: 0xe227,
  bar_chart_off: 0xf411,
  book_5: 0xf53b,
  cancel: 0xe5c9,
  check: 0xe5ca,
  check_circle: 0xe86c,
  chevron_backward: 0xf46b,
  chevron_forward: 0xf46a,
  chevron_left: 0xe408,
  chevron_right: 0xe409,
  circle: 0xef4a,
  close: 0xe14c,
  corporate_fare: 0xf1d0,
  credit_card: 0xe870,
  delete: 0xe872,
  description: 0xe873,
  download: 0xe171,
  edit: 0xe150,
  error: 0xe000,
  find_in_page: 0xe880,
  format_list_bulleted: 0xe241,
  group: 0xe7ef,
  home: 0xe88a,
  info: 0xe88e,
  integration_instructions: 0xef54,
  key: 0xe73c,
  key_vertical: 0xf51a,
  keyboard_arrow_down: 0xe313,
  lock: 0xe88d,
  logout: 0xe9ba,
  more_vert: 0xe5d4,
  open_in_new: 0xe895,
  orders: 0xeb14,
  payment_arrow_down: 0xf2c0,
  photo_prints: 0xefb2,
  print: 0xe555,
  refresh: 0xe5d5,
  remove: 0xe15b,
  replay: 0xe042,
  search: 0xe8b6,
  settings: 0xe8b8,
  tune: 0xe429,
  unfold_more: 0xe5d7,
  upload: 0xe2c6,
  upload_file: 0xe9fc,
  warning: 0xe002,
} as const;

/** Every icon the subsetted font can render. */
export type IconName = keyof typeof ICON_CODEPOINTS;
